import { render, staticRenderFns } from "./MotivoForm.vue?vue&type=template&id=90f020e8"
import script from "./MotivoForm.vue?vue&type=script&lang=js"
export * from "./MotivoForm.vue?vue&type=script&lang=js"
import style0 from "./MotivoForm.vue?vue&type=style&index=0&id=90f020e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports